<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="55%"
            :fullscreen="windowWidth < 1000">

        <div class="orc-step" style="margin-top: -20px;">
            <h1 v-if="activeTab == 0">Personalia</h1>
            <h1 v-if="activeTab == 1">Noodgevallen</h1>
            <h1 v-if="activeTab == 2">Andere</h1>
            <h1 v-if="activeTab == 3">Finaliseren</h1>
        </div>
        
        <el-steps :active="activeTab" align-center class="orc-steps">
            <el-step title="Personalia" description="Persoonlijke gegevens"></el-step>
            <el-step title="Noodgevallen" description="In geval van nood"></el-step>
            <el-step title="Andere" description="Extra informatie"></el-step>
            <el-step title="Finaliseren" description="Voorwaarden"></el-step>
        </el-steps>

        <div class="mt-8">
            <div v-if="activeTab == 0">
                <el-form :model="obj" ref="personalForm" status-icon :rules="personalRules">
                    <el-row :gutter="10">
                        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
                            <el-form-item prop="gender">
                                <el-select v-model="obj.gender" placeholder="Geslacht" class="w-full">
                            <span slot="prefix">
                                <div v-if="obj.gender">
                                    <i class="el-icon-male pl-1"></i>
                                </div>
                                <div v-else>
                                    <i class="el-icon-female pl-1"></i>
                                </div>
                            </span>
                                    <el-option
                                            v-for="item in genderOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
                            <el-form-item prop="firstName">
                                <el-input placeholder="Voornaam" v-model="obj.firstName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="lastName">
                                <el-input placeholder="Achternaam" v-model="obj.lastName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="email">
                                <el-input placeholder="E-mail" v-model="obj.email" type="email"
                                          prefix-icon="el-icon-message"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="cellPhone">
                                <el-input placeholder="Telefoon" v-model="obj.cellPhone"
                                          prefix-icon="el-icon-mobile-phone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="birthDate">
                                <el-date-picker
                                        v-model="obj.birthDate"
                                        type="date"
                                        class="w-full"
                                        placeholder="Geboortedatum">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="nationality">
                                <el-input placeholder="Nationaliteit" v-model="obj.nationality"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10">
                        <el-col :xs="16" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item prop="street">
                                <el-input placeholder="Straat" v-model="obj.street"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4">
                            <el-form-item prop="number">
                                <el-input placeholder="Nummer" v-model="obj.number"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="8" :sm="4" :md="4" :lg="4" :xl="4">
                            <el-form-item prop="postal">
                                <el-input placeholder="Postcode" v-model="obj.postal"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="16" :sm="8" :md="8" :lg="8" :xl="8">
                            <el-form-item prop="city">
                                <el-input placeholder="Stad" v-model="obj.city"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="country">
                                <el-select v-model="obj.country"
                                           placeholder="Land"
                                           class="w-full">
                                         <span slot="prefix">
                                            <i class="el-icon-location-outline pl-1"></i>
                                        </span>
                                    <el-option
                                            v-for="item in countryOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="branchId">
                                <el-select v-model="obj.branchId"
                                           placeholder="Tak"
                                           class="w-full">
                                     <span slot="prefix">
                                            <i class="el-icon-medal pl-1"></i>
                                     </span>
                                    <el-option
                                            v-for="item in nonPseudoBranches"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                            :disabled="!item.active">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-if="activeTab == 1">
                <el-form :model="obj" ref="emergencyForm" status-icon :rules="emergencyRules">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="emgFirstName">
                                <el-input placeholder="Contact voornaam" v-model="obj.emgFirstName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="emgLastName">
                                <el-input placeholder="Contact achternaam" v-model="obj.emgLastName"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item prop="emgCellPhone">
                                <el-input placeholder="Contact telefoon" v-model="obj.emgCellPhone"
                                          prefix-icon="el-icon-mobile-phone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-if="activeTab == 2">
                <el-form :model="obj" ref="otherForm" status-icon :rules="otherRules">
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="accountNumber">
                                <el-input placeholder="Rekeningnummer" v-model="obj.accountNumber"
                                          prefix-icon="el-icon-bank-card"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item prop="nationalInsuranceNumber">
                                <el-input placeholder="Rijksregisternummer" v-model="obj.nationalInsuranceNumber"
                                          prefix-icon="el-icon-user"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item prop="formations">
                                <el-input type="textarea"
                                          v-model="obj.formations"
                                          placeholder="Opleidingen en vormingen"
                                          maxlength="60"
                                          show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="24">
                            <el-form-item prop="annotations">
                                <el-input type="textarea"
                                          v-model="obj.annotations"
                                          placeholder="Opmerkingen"
                                          maxlength="60"
                                          show-word-limit></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div v-if="activeTab == 3" class="px-4">

                <el-alert
                        v-if="branch && branch.annotation && branch.annotation.length > 0"
                        :title="getAlertTitle"
                        type="info"
                        :description="branch.annotation"
                        show-icon
                        class="mb-4"
                        :closable="false">
                </el-alert>

                <p class="my-6 mt-8 break-normal">
                    Uw inschrijving {{ branch.name.toLowerCase() }} is pas definitief na betaling van het lidgeld. Voer onderstaande overschrijving uit met een vermelding van de naam van het ingeschreven lid.
                </p>

                <el-tooltip class="item" effect="dark"
                            content="Rekeningnummer inschrijving" placement="top">
                    <el-input
                            placeholder="Rekeningnummer"
                            v-model="branch.enrollmentAccountNumber"
                            prefix-icon="el-icon-bank-card"
                            class="mb-4"
                            :readonly="true"></el-input>
                </el-tooltip>

                <el-tooltip class="item" effect="dark"
                            content="Kost inschrijving" placement="top">
                    <el-input
                            placeholder="Inschrijvingsgeld"
                            v-model="branch.enrollmentPrice"
                            prefix-icon="el-icon-money"
                            type="number"
                            :readonly="true">
                        <template slot="append">EUR</template>
                    </el-input>
                </el-tooltip>

                <div class="pt-3">
                    <el-checkbox v-model="accepted">Ik ga akkoord met de <span class="text-primary"><a @click="openRules()">algemene voorwaarden</a></span></el-checkbox>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false" v-if="activeTab == 0">Annuleer</el-button>
            <el-button @click="previousTab()" v-if="activeTab > 0">Vorige</el-button>
            <el-button type="primary" @click="nextTab(formPerStep[activeTab])" :disabled="activeTab === maxTabs && !accepted" :loading="loading">
                <span v-if="activeTab < maxTabs">Volgende</span>
                <span v-else>Inschrijven<i class="ml-2 el-icon-right"></i></span>
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "EnrollmentDialog",
        props: ['branchOptions'],
        data() {
            return {
                dialogTitle: "",
                itemName: "Inschrijving",
                dialogVisible: false,
                adding: false,
                obj: this.getEmptyObject(),
                loading: false,
                activeTab: 0,
                maxTabs: 3,
                accepted: false,
                branch: {},
                windowWidth: window.innerWidth,

                // RulesPerStep
                formPerStep: [
                    'personalForm',
                    'emergencyForm',
                    'otherForm'
                ],

                // Options
                genderOptions: [
                    {
                        value: true,
                        label: "Man"
                    }, {
                        value: false,
                        label: "Vrouw"
                    }
                ],
                countryOptions: [
                    {
                        value: 0,
                        label: "België"
                    },
                    {
                        value: 1,
                        label: "Nederland"
                    }
                ],

                // Rules
                personalRules: {
                    firstName: [
                        {required: true, message: 'Vul een naam in.', trigger: 'blur'}
                    ],
                    lastName: [
                        {required: true, message: 'Vul een achternaam in.', trigger: 'blur'}
                    ],
                    email: [
                        {type: 'email', required: true, message: 'Vul een geldig email adres in.', trigger: 'blur'}
                    ],
                    cellPhone: [
                        {required: true, message: 'Vul een telefoonnummer in.', trigger: 'blur'}
                    ],
                    gender: [
                        {required: true, message: 'Selecteer een geslacht.', trigger: 'blur'}
                    ],
                    birthDate: [
                        {required: true, message: 'Selecteer een geboortedatum.', trigger: 'blur'}
                    ],
                    street: [
                        {required: true, message: 'Vul een straat in.', trigger: 'blur'}
                    ],
                    number: [
                        {required: true, message: 'Vul nummer in.', trigger: 'blur'}
                    ],
                    city: [
                        {required: true, message: 'Vul een stad in.', trigger: 'blur'}
                    ],
                    postal: [
                        {required: true, message: 'Vul postcode in.', trigger: 'blur'}
                    ],
                    nationality: [
                        {required: true, message: 'Vul een nationaliteit in.', trigger: 'blur'}
                    ],
                    branchId: [
                        {required: true, message: 'Selecteer een tak.', trigger: 'blur'}
                    ],
                    country: [
                        {required: true, message: 'Selecteer een land.', trigger: 'blur'}
                    ],
                },
                emergencyRules: {
                    emgFirstName: [
                        {required: true, message: 'Vul naam contactpersoon in.', trigger: 'blur'}
                    ],
                    emgLastName: [
                        {required: true, message: 'Vul achternaam contactpersoon in.', trigger: 'blur'}
                    ],
                    emgCellPhone: [
                        {required: true, message: 'Vul telefoonnummer contactpersoon in.', trigger: 'blur'}
                    ],
                },
                otherRules: {
                    nationalInsuranceNumber: [
                        {required: true, message: 'Vul rijksregisternummer in.', trigger: 'blur'}
                    ],
                    accountNumber: [
                        {required: true, message: 'Vul rekeningnummer in.', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj));
                this.reset();
            },
            add(branchId) {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                this.reset();

                if(branchId != null){
                    this.obj.branchId = branchId;
                }
            },
            newEnrollment() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                this.reset();
            },
            reset() {
                if(this.$refs['personalForm']) {
                    this.$refs['personalForm'].resetFields()
                }

                if(this.$refs['emergencyForm']){
                    this.$refs['emergencyForm'].resetFields()
                }

                if(this.$refs['otherForm']) {
                    this.$refs['otherForm'].resetFields()
                }
                this.activeTab = 0
            },
            getEmptyObject() {
                return {
                    // Form data
                    firstName: "",
                    lastName: "",
                    roles: "",
                    email: "",
                    cellPhone: "",
                    gender: null,
                    birthDate: "",
                    street: "",
                    number: "",
                    city: "",
                    postal: "",
                    region: "",
                    country: "",
                    nationality: "",
                    branches: "",
                    emgFirstName: "",
                    emgLastName: "",
                    emgCellPhone: "",
                    nationalInsuranceNumber: "",
                    accountNumber: "",
                    formations: "",
                    annotations: "",
                }
            },
            previousTab() {
                // Clear validation result
                // TODO?
                if(this.activeTab > 0) {
                    this.activeTab = this.activeTab - 1;
                    console.log(this.activeTab)
                }
            },
            nextTab(formName) {
                if (this.activeTab < this.maxTabs) {
                    this.$refs[formName].validate((valid) => {
                        if (valid) {
                            // Fetch branch details
                            if(this.activeTab === 0) {
                                this.fetchBranch(this.obj.branchId)
                            }
                            if (this.activeTab < this.maxTabs) {
                                this.activeTab = this.activeTab + 1;
                            }
                        } else {
                            this.openAlert('Gelieve alle informatie correct in te vullen.', 'error')
                        }
                    });
                } else {
                    // Submit button clicked
                    this.submitEnrollment()
                }
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
            openAlert(msg, type) {
                this.$message({
                    showClose: true,
                    message: msg,
                    type: type
                });
                return false;
            },
            openRules() {
                let route = this.$router.resolve({path: 'terms'});
                window.open(route.href, '_blank');
            },
            fetchBranch(branchId) {
                this.$http.get(`branches/${branchId}`).then((response) => {
                    this.branch = response.data
                }).catch(function (error) {
                    console.log(error)
                })
            },
            submitEnrollment() {
                // Add API call here
                this.loading = true
                this.$http.post('enrollments', this.obj).then((response) => {
                    this.openAlert('Inschrijving geregistreerd.', 'success')
                    this.loading = false
                    this.dialogVisible = false
                }).catch((error) => {
                    this.openAlert('Kon inschrijving niet verwerken, probeer later opnieuw.', 'error')
                    console.log(error);
                })
            }
        },
        mounted() {
            window.onresize = () => {
                this.windowWidth = window.innerWidth
            }
        },
        computed: {
            getAlertTitle() {
                if (this.branch) {
                    return `Inschrijving ${this.branch.name}`
                } else {
                    return "N/A"
                }
            },
            nonPseudoBranches() {
                if (this.branchOptions) {
                    return this.branchOptions.filter(e => {
                        return !e.pseudo
                    })
                } else {
                    return []
                }
            }
        }
    }
</script>

<style scoped>
  @media only screen and (max-width: 600px) {
    .orc-steps {
      display: none;
    }

    .orc-step {
      display: block;
    }
  }

  @media only screen and (min-width: 600px) {

    .orc-step {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/enrollments/dialogs/EnrollmentDialog.vue